import React from 'react';
import { ReactComponent as OpenAccordion } from '../../../../svg/open-accordion.svg';
import { ReactComponent as CloseAccordion } from '../../../../svg/close-accordion.svg';

export function ActivePlus({ isOpen }) {
  return isOpen ? <CloseAccordion /> : <OpenAccordion />;
}
